import AddStepAction from './addStepAction.js';
import Track from 'track/Track.js';

class RecordStepAction extends AddStepAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({
        track,
        step,
        stepNumber,
        resolution=Track.baseResolution,
        displayResolution=Track.baseResolution,
        isQuantized=true
    }, updateRedux=true) {
        super.execute(
            {track, step, stepNumber, resolution, isRecording: true, displayResolution, isQuantized},
            updateRedux);
    }
}

export default RecordStepAction;
